import { atom, useAtom, useAtomValue, useStore } from "jotai";
import { useEffect } from "react";

import { useGridSettingsSelect } from "../../data";
import { useCalcs } from "../calcs/react";

export const eodDateAtom = atom<string | null>(null);
eodDateAtom.debugLabel = "eodDateAtom";
export const useGridSettingsEodDate = () => useAtomValue(eodDateAtom);

export const gridSettingsVisibleAtom = atom<boolean>(false);
gridSettingsVisibleAtom.debugLabel = "gridSettingsVisibleAtom";
export const useGridSettingsVisible = () => useAtom(gridSettingsVisibleAtom);

export const prefetchGridSettings = () => import("./Settings");

export const useGridSettingsWidth = () => 0;

export const SyncGridSettings = () => {
  const eodDate = useGridSettingsSelect((x) => x?.eod_date);
  const store = useStore();
  const calcWorker = useCalcs();

  useEffect(() => {
    if (eodDate.data !== "prior") {
      store.set(eodDateAtom, eodDate.data ?? null);
      return;
    }
    Promise.resolve(calcWorker?.getPriorEodDate()).then((date) => {
      return store.set(eodDateAtom, date ?? null);
    });
  }, [calcWorker, store, eodDate.data]);

  return null;
};
